import React, { useState } from "react";
import Eye from "../../../assets/auth-icons/eye.svg";
import "./PasswordInput.scss";

interface PasswordInputProps {
  label: string;
  value: string;
  placeholder: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  error?: string;
  type: string;
}

const PasswordInput: React.FC<PasswordInputProps> = ({
  label,
  value,
  placeholder,
  onChange,
  error,
  type
}) => {
  const [showPassword, setShowPassword] = useState<boolean>(type === "password");

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="inp-col">
      <label>{label}</label>
      <div className="input-wrapper">
        <input
          type={showPassword ? "text" : "password"}
          value={value}
          placeholder={placeholder}
          onChange={onChange}
        />
        <img
          src={Eye} 
          alt="toggle visibility"
          className={`eye-icon ${showPassword ? "visible" : "hidden"}`}
          onClick={togglePasswordVisibility}
        />
      </div>
      {error && <p style={{ color: "red" }}>{error}</p>}
    </div>
  );
};

export default PasswordInput;
